import _ from 'lodash'
import configment from '@adc/configment'

const embeddableOperation = name =>
  [_.camelCase(configment.get('APP_NAME', '')), name].filter(Boolean).join('_')

export { embeddableOperation }
